import { SettingOutlined } from "@ant-design/icons";
import React from "react";
import { toast } from "react-toastify";
import { Button, Form, Modal, TextInput } from "src/Components";
import { IStepFundSellSettings } from "src/Interfaces/stepInterfaces";
import {
  getStepFundSellSettings,
  setStepFundSellSettings,
} from "src/Requests/stepRequests";
import { packetErrorHandler } from "src/Utils/requestUtils";

const FundSellSettings = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [formValues, setFormValues] = React.useState<IStepFundSellSettings>(
    {} as IStepFundSellSettings,
  );

  React.useEffect(() => {
    if (!isOpen) return;
    getStepFundSellSettings().then(setFormValues).catch(packetErrorHandler);
  }, [isOpen]);

  const changeHandler = (name: string, value: string) => {
    setFormValues({
      ...formValues,
      [name]: Number(value),
    });
  };

  const submitHandler = () => {
    setLoading(true);
    setStepFundSellSettings(formValues)
      .then((resp) => {
        if (resp.data) toast.success(resp.msg);
        else toast.error(resp.msg);
        setIsOpen(false);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div
        className="flex flex-row justify-start items-center w-full gap-3 p-2 border-2 rounded border-gray-300 hover:border-gray-500 transition-all duration-200 cursor-pointer"
        onClick={() => setIsOpen(true)}
      >
        <SettingOutlined />
        <div className="text-xs">تنظیمات فروش صندوق درآمد ثابت</div>
      </div>
      {isOpen ? (
        <Modal
          title="تنظیم فروش صندوق"
          onClose={() => setIsOpen(false)}
          modalBoxClassName="!min-w-0 !w-auto !min-h-min"
          UI={
            <Form className="p-3 gap-3 !w-72">
              <TextInput
                label="تعداد بلوک جلوتر برای فروش صندوق-کمین"
                name="aheadBlocks"
                value={formValues.aheadBlocks?.toString() ?? ""}
                onChange={changeHandler}
                kind="number"
                extraLabel
              />
              <Button
                onClick={submitHandler}
                text="ثبت"
                variant="contained"
                loading={loading}
                disabled={formValues.aheadBlocks == null}
              />
            </Form>
          }
        />
      ) : null}
    </>
  );
};

export default FundSellSettings;
